
import React from 'react'

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="simple-spinner"></div>
        </div>)
}

export default Loader
